const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sandboxes/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { sandboxCatalogGroups } from "@/lib/sandbox-catalog";
import { sandboxCatalogQueryOptions } from "@/queries/sandbox-catalog";
import { sandboxHubQueryOptions } from "@/queries/sandbox-hub";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/sandboxes/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      id
    } = params;
    const {
      country,
      queryClient
    } = context;
    await queryClient.ensureQueryData(sandboxHubQueryOptions({
      id,
      country: country || "US",
      offerLimit: 8,
      updateLimit: 8
    })).catch(() => null);
    await Promise.all(sandboxCatalogGroups.map(group => queryClient.prefetchQuery(sandboxCatalogQueryOptions(id, {
      q: "",
      group: group.id,
      types: "",
      page: 1,
      pageSize: 4
    }, country || "US"))));
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  }
});